module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.opened) ? _c('div', {
    staticClass: "contents"
  }, [(_vm.rulesLoaded && _vm.shouldAskDuration) ? _c('div', {
    staticClass: "time-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('time_stage.start_time')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('time_stage.end_time')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "time-selection-columns"
  }, [(_vm.rulesLoaded) ? _c('div', {
    staticClass: "from-list scroll-height"
  }, [(_vm.startTimeSet && _vm.shouldAskDuration) ? _c('div', {
    staticClass: "time-list--blurred"
  }, [_c('div', {
    staticClass: "time-list--blurred-details"
  }, [_c('div', {
    staticClass: "current-selection"
  }, [_vm._v("\n                    " + _vm._s(_vm.DateService.friendlyTime(_vm.selectedStartTime.time)) + "\n                    "), _c('strong', {
    on: {
      "click": _vm.unselectStartTime
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('global.change')) + "\n                    ")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('time_stage.end_time_prompt')))])])]) : _vm._e(), _vm._v(" "), (_vm.startTimesLoading) ? _vm._l((5), function(n) {
    return _c('list-slot', {
      key: 'fromTimePlaceholder' + n,
      attrs: {
        "placeholder": true
      }
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.startTimeSet) ? _vm._l((_vm.startTimes), function(fromSlot) {
    return _c('list-slot', {
      key: fromSlot.uniqueId,
      attrs: {
        "main-text": _vm.DateService.friendlyTime(fromSlot.time),
        "main-detail": !_vm.shouldAskDuration ? _vm.getFriendlyEndTime(fromSlot.time) : false,
        "sub-text": fromSlot.subtext ? _vm.$t(("time_stage." + (fromSlot.subtext))) : '',
        "offers": _vm.getOffersForSlot(fromSlot),
        "centralise": !_vm.shouldAskDuration,
        "disabled": fromSlot.isDisabled,
        "selected": _vm.isTimeSelected(fromSlot),
        "instant": fromSlot.isInstant,
        "no-arrow": "true"
      },
      on: {
        "click": function($event) {
          _vm.selectStartTime(fromSlot)
        },
        "disabledClick": function($event) {
          _vm.offerAlternativesForSlot(fromSlot)
        }
      }
    })
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.rulesLoaded && _vm.shouldAskDuration) ? _c('div', {
    staticClass: "until-list scroll-height"
  }, [(!_vm.startTimeSet) ? _c('div', {
    staticClass: "time-list--blurred"
  }, [_c('div', {
    staticClass: "time-list--blurred-details"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('time_stage.start_time_prompt')) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.startTimeSet && _vm.endTimesLoading) ? _vm._l((5), function(n) {
    return _c('list-slot', {
      key: 'untilPlaceholder' + n,
      attrs: {
        "placeholder": true
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.startTimeSet) ? _vm._l((_vm.endTimes), function(untilSlot) {
    return _c('list-slot', {
      key: untilSlot.duration === -1 ? 'untilclose' : untilSlot.uniqueId,
      attrs: {
        "main-text": untilSlot.duration === -1 ? _vm.$t('time_stage.until_close') : _vm.DateService.friendlyTime(untilSlot.time),
        "sub-text": _vm.$t(("time_stage." + (untilSlot.subtext))),
        "offers": _vm.getOffersForSlot(untilSlot),
        "disabled": untilSlot.isDisabled,
        "instant": untilSlot.isInstant
      },
      on: {
        "click": function($event) {
          _vm.selectEndTime(untilSlot)
        },
        "disabledClick": function($event) {
          _vm.offerAlternativesForSlot(_vm.fromSlot)
        }
      }
    })
  }) : _vm._e()], 2) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2998ba9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeStage.vue
// module id = 591
// module chunks = 0